import type { PolygonStyle } from 'fifa-gis-library'
import { leafletToMapboxGeoFenceStyle } from 'frontend/live-panel/helpers/leaflet-to-mapbox-adapters'

export const clusterGeoFenceStyle: PolygonStyle = {
  fillColor: '#0080ff',
  fillOpacity: 0.2,
  strokeColor: '#0080ff',
  strokeOpacity: 0.4,
  strokeWeight: 1,
}

export const mapBoxClusterGeoFenceStyle = leafletToMapboxGeoFenceStyle(clusterGeoFenceStyle)
